import { queryRef, executeQuery, validateArgsWithOptions, mutationRef, executeMutation, validateArgs } from 'firebase/data-connect';

export const connectorConfig = {
  connector: 'alumni-connector',
  service: 'alumni-1f8c2-service',
  location: 'us-east4'
};
export const addAlumnoRef = (dcOrVars, vars) => {
  const { dc: dcInstance, vars: inputVars} = validateArgs(connectorConfig, dcOrVars, vars, true);
  dcInstance._useGeneratedSdk();
  return mutationRef(dcInstance, 'AddAlumno', inputVars);
}
addAlumnoRef.operationName = 'AddAlumno';

export function addAlumno(dcOrVars, vars) {
  const { dc: dcInstance, vars: inputVars } = validateArgs(connectorConfig, dcOrVars, vars, true);
  return executeMutation(addAlumnoRef(dcInstance, inputVars));
}

export const addContinuousTrainingRef = (dcOrVars, vars) => {
  const { dc: dcInstance, vars: inputVars} = validateArgs(connectorConfig, dcOrVars, vars, true);
  dcInstance._useGeneratedSdk();
  return mutationRef(dcInstance, 'AddContinuousTraining', inputVars);
}
addContinuousTrainingRef.operationName = 'AddContinuousTraining';

export function addContinuousTraining(dcOrVars, vars) {
  const { dc: dcInstance, vars: inputVars } = validateArgs(connectorConfig, dcOrVars, vars, true);
  return executeMutation(addContinuousTrainingRef(dcInstance, inputVars));
}

export const addPlanInstitucionRef = (dcOrVars, vars) => {
  const { dc: dcInstance, vars: inputVars} = validateArgs(connectorConfig, dcOrVars, vars, true);
  dcInstance._useGeneratedSdk();
  return mutationRef(dcInstance, 'AddPlanInstitucion', inputVars);
}
addPlanInstitucionRef.operationName = 'AddPlanInstitucion';

export function addPlanInstitucion(dcOrVars, vars) {
  const { dc: dcInstance, vars: inputVars } = validateArgs(connectorConfig, dcOrVars, vars, true);
  return executeMutation(addPlanInstitucionRef(dcInstance, inputVars));
}

export const updatePlanInstitucionRef = (dcOrVars, vars) => {
  const { dc: dcInstance, vars: inputVars} = validateArgs(connectorConfig, dcOrVars, vars, true);
  dcInstance._useGeneratedSdk();
  return mutationRef(dcInstance, 'UpdatePlanInstitucion', inputVars);
}
updatePlanInstitucionRef.operationName = 'UpdatePlanInstitucion';

export function updatePlanInstitucion(dcOrVars, vars) {
  const { dc: dcInstance, vars: inputVars } = validateArgs(connectorConfig, dcOrVars, vars, true);
  return executeMutation(updatePlanInstitucionRef(dcInstance, inputVars));
}

export const addRegistroBitacoraRef = (dcOrVars, vars) => {
  const { dc: dcInstance, vars: inputVars} = validateArgs(connectorConfig, dcOrVars, vars, true);
  dcInstance._useGeneratedSdk();
  return mutationRef(dcInstance, 'AddRegistroBitacora', inputVars);
}
addRegistroBitacoraRef.operationName = 'AddRegistroBitacora';

export function addRegistroBitacora(dcOrVars, vars) {
  const { dc: dcInstance, vars: inputVars } = validateArgs(connectorConfig, dcOrVars, vars, true);
  return executeMutation(addRegistroBitacoraRef(dcInstance, inputVars));
}

export const insertAlumniUserMfaVaultRef = (dcOrVars, vars) => {
  const { dc: dcInstance, vars: inputVars} = validateArgs(connectorConfig, dcOrVars, vars, true);
  dcInstance._useGeneratedSdk();
  return mutationRef(dcInstance, 'InsertAlumniUserMfaVault', inputVars);
}
insertAlumniUserMfaVaultRef.operationName = 'InsertAlumniUserMfaVault';

export function insertAlumniUserMfaVault(dcOrVars, vars) {
  const { dc: dcInstance, vars: inputVars } = validateArgs(connectorConfig, dcOrVars, vars, true);
  return executeMutation(insertAlumniUserMfaVaultRef(dcInstance, inputVars));
}

export const updateAlumniUserMfaVaultRef = (dcOrVars, vars) => {
  const { dc: dcInstance, vars: inputVars} = validateArgs(connectorConfig, dcOrVars, vars, true);
  dcInstance._useGeneratedSdk();
  return mutationRef(dcInstance, 'UpdateAlumniUserMfaVault', inputVars);
}
updateAlumniUserMfaVaultRef.operationName = 'UpdateAlumniUserMfaVault';

export function updateAlumniUserMfaVault(dcOrVars, vars) {
  const { dc: dcInstance, vars: inputVars } = validateArgs(connectorConfig, dcOrVars, vars, true);
  return executeMutation(updateAlumniUserMfaVaultRef(dcInstance, inputVars));
}

export const deleteAlumniUserMfaVaultRef = (dcOrVars, vars) => {
  const { dc: dcInstance, vars: inputVars} = validateArgs(connectorConfig, dcOrVars, vars, true);
  dcInstance._useGeneratedSdk();
  return mutationRef(dcInstance, 'DeleteAlumniUserMfaVault', inputVars);
}
deleteAlumniUserMfaVaultRef.operationName = 'DeleteAlumniUserMfaVault';

export function deleteAlumniUserMfaVault(dcOrVars, vars) {
  const { dc: dcInstance, vars: inputVars } = validateArgs(connectorConfig, dcOrVars, vars, true);
  return executeMutation(deleteAlumniUserMfaVaultRef(dcInstance, inputVars));
}

export const getAlumniUserMfaVaultByFirebaseUidRef = (dcOrVars, vars) => {
  const { dc: dcInstance, vars: inputVars} = validateArgs(connectorConfig, dcOrVars, vars, true);
  dcInstance._useGeneratedSdk();
  return queryRef(dcInstance, 'GetAlumniUserMfaVaultByFirebaseUid', inputVars);
}
getAlumniUserMfaVaultByFirebaseUidRef.operationName = 'GetAlumniUserMfaVaultByFirebaseUid';

export function getAlumniUserMfaVaultByFirebaseUid(dcOrVars, varsOrOptions, options) {
  
  const { dc: dcInstance, vars: inputVars, options: inputOpts } = validateArgsWithOptions(connectorConfig, dcOrVars, varsOrOptions, options, true, true);
  return executeQuery(getAlumniUserMfaVaultByFirebaseUidRef(dcInstance, inputVars), inputOpts && { fetchPolicy: inputOpts.fetchPolicy });
}

export const deleteAlumnoRef = (dcOrVars, vars) => {
  const { dc: dcInstance, vars: inputVars} = validateArgs(connectorConfig, dcOrVars, vars, true);
  dcInstance._useGeneratedSdk();
  return mutationRef(dcInstance, 'DeleteAlumno', inputVars);
}
deleteAlumnoRef.operationName = 'DeleteAlumno';

export function deleteAlumno(dcOrVars, vars) {
  const { dc: dcInstance, vars: inputVars } = validateArgs(connectorConfig, dcOrVars, vars, true);
  return executeMutation(deleteAlumnoRef(dcInstance, inputVars));
}

export const deleteAlumnoContinuousTrainingRef = (dcOrVars, vars) => {
  const { dc: dcInstance, vars: inputVars} = validateArgs(connectorConfig, dcOrVars, vars, true);
  dcInstance._useGeneratedSdk();
  return mutationRef(dcInstance, 'DeleteAlumnoContinuousTraining', inputVars);
}
deleteAlumnoContinuousTrainingRef.operationName = 'DeleteAlumnoContinuousTraining';

export function deleteAlumnoContinuousTraining(dcOrVars, vars) {
  const { dc: dcInstance, vars: inputVars } = validateArgs(connectorConfig, dcOrVars, vars, true);
  return executeMutation(deleteAlumnoContinuousTrainingRef(dcInstance, inputVars));
}

export const insertEnlaceTemporalRef = (dcOrVars, vars) => {
  const { dc: dcInstance, vars: inputVars} = validateArgs(connectorConfig, dcOrVars, vars, true);
  dcInstance._useGeneratedSdk();
  return mutationRef(dcInstance, 'InsertEnlaceTemporal', inputVars);
}
insertEnlaceTemporalRef.operationName = 'InsertEnlaceTemporal';

export function insertEnlaceTemporal(dcOrVars, vars) {
  const { dc: dcInstance, vars: inputVars } = validateArgs(connectorConfig, dcOrVars, vars, true);
  return executeMutation(insertEnlaceTemporalRef(dcInstance, inputVars));
}

export const getEnlaceTemporalByTokenHashRef = (dcOrVars, vars) => {
  const { dc: dcInstance, vars: inputVars} = validateArgs(connectorConfig, dcOrVars, vars, true);
  dcInstance._useGeneratedSdk();
  return queryRef(dcInstance, 'GetEnlaceTemporalByTokenHash', inputVars);
}
getEnlaceTemporalByTokenHashRef.operationName = 'GetEnlaceTemporalByTokenHash';

export function getEnlaceTemporalByTokenHash(dcOrVars, varsOrOptions, options) {
  
  const { dc: dcInstance, vars: inputVars, options: inputOpts } = validateArgsWithOptions(connectorConfig, dcOrVars, varsOrOptions, options, true, true);
  return executeQuery(getEnlaceTemporalByTokenHashRef(dcInstance, inputVars), inputOpts && { fetchPolicy: inputOpts.fetchPolicy });
}

export const updateEnlaceTemporalEstadoRef = (dcOrVars, vars) => {
  const { dc: dcInstance, vars: inputVars} = validateArgs(connectorConfig, dcOrVars, vars, true);
  dcInstance._useGeneratedSdk();
  return mutationRef(dcInstance, 'UpdateEnlaceTemporalEstado', inputVars);
}
updateEnlaceTemporalEstadoRef.operationName = 'UpdateEnlaceTemporalEstado';

export function updateEnlaceTemporalEstado(dcOrVars, vars) {
  const { dc: dcInstance, vars: inputVars } = validateArgs(connectorConfig, dcOrVars, vars, true);
  return executeMutation(updateEnlaceTemporalEstadoRef(dcInstance, inputVars));
}

export const listEnlaceTemporalActivosRef = (dcOrVars, vars) => {
  const { dc: dcInstance, vars: inputVars} = validateArgs(connectorConfig, dcOrVars, vars);
  dcInstance._useGeneratedSdk();
  return queryRef(dcInstance, 'ListEnlaceTemporalActivos', inputVars);
}
listEnlaceTemporalActivosRef.operationName = 'ListEnlaceTemporalActivos';

export function listEnlaceTemporalActivos(dcOrVars, varsOrOptions, options) {
  
  const { dc: dcInstance, vars: inputVars, options: inputOpts } = validateArgsWithOptions(connectorConfig, dcOrVars, varsOrOptions, options, true, false);
  return executeQuery(listEnlaceTemporalActivosRef(dcInstance, inputVars), inputOpts && { fetchPolicy: inputOpts.fetchPolicy });
}

export const listEnlaceTemporalByInstitucionRef = (dcOrVars, vars) => {
  const { dc: dcInstance, vars: inputVars} = validateArgs(connectorConfig, dcOrVars, vars, true);
  dcInstance._useGeneratedSdk();
  return queryRef(dcInstance, 'ListEnlaceTemporalByInstitucion', inputVars);
}
listEnlaceTemporalByInstitucionRef.operationName = 'ListEnlaceTemporalByInstitucion';

export function listEnlaceTemporalByInstitucion(dcOrVars, varsOrOptions, options) {
  
  const { dc: dcInstance, vars: inputVars, options: inputOpts } = validateArgsWithOptions(connectorConfig, dcOrVars, varsOrOptions, options, true, true);
  return executeQuery(listEnlaceTemporalByInstitucionRef(dcInstance, inputVars), inputOpts && { fetchPolicy: inputOpts.fetchPolicy });
}

export const listEnlaceTemporalByInstitucionCountRef = (dcOrVars, vars) => {
  const { dc: dcInstance, vars: inputVars} = validateArgs(connectorConfig, dcOrVars, vars, true);
  dcInstance._useGeneratedSdk();
  return queryRef(dcInstance, 'ListEnlaceTemporalByInstitucionCount', inputVars);
}
listEnlaceTemporalByInstitucionCountRef.operationName = 'ListEnlaceTemporalByInstitucionCount';

export function listEnlaceTemporalByInstitucionCount(dcOrVars, varsOrOptions, options) {
  
  const { dc: dcInstance, vars: inputVars, options: inputOpts } = validateArgsWithOptions(connectorConfig, dcOrVars, varsOrOptions, options, true, true);
  return executeQuery(listEnlaceTemporalByInstitucionCountRef(dcInstance, inputVars), inputOpts && { fetchPolicy: inputOpts.fetchPolicy });
}

export const findAlumnoRef = (dcOrVars, vars) => {
  const { dc: dcInstance, vars: inputVars} = validateArgs(connectorConfig, dcOrVars, vars, true);
  dcInstance._useGeneratedSdk();
  return queryRef(dcInstance, 'FindAlumno', inputVars);
}
findAlumnoRef.operationName = 'FindAlumno';

export function findAlumno(dcOrVars, varsOrOptions, options) {
  
  const { dc: dcInstance, vars: inputVars, options: inputOpts } = validateArgsWithOptions(connectorConfig, dcOrVars, varsOrOptions, options, true, true);
  return executeQuery(findAlumnoRef(dcInstance, inputVars), inputOpts && { fetchPolicy: inputOpts.fetchPolicy });
}

export const findAlumnoByCurpRef = (dcOrVars, vars) => {
  const { dc: dcInstance, vars: inputVars} = validateArgs(connectorConfig, dcOrVars, vars, true);
  dcInstance._useGeneratedSdk();
  return queryRef(dcInstance, 'FindAlumnoByCurp', inputVars);
}
findAlumnoByCurpRef.operationName = 'FindAlumnoByCurp';

export function findAlumnoByCurp(dcOrVars, varsOrOptions, options) {
  
  const { dc: dcInstance, vars: inputVars, options: inputOpts } = validateArgsWithOptions(connectorConfig, dcOrVars, varsOrOptions, options, true, true);
  return executeQuery(findAlumnoByCurpRef(dcInstance, inputVars), inputOpts && { fetchPolicy: inputOpts.fetchPolicy });
}

export const findAlumnoByNumeroControlRef = (dcOrVars, vars) => {
  const { dc: dcInstance, vars: inputVars} = validateArgs(connectorConfig, dcOrVars, vars, true);
  dcInstance._useGeneratedSdk();
  return queryRef(dcInstance, 'FindAlumnoByNumeroControl', inputVars);
}
findAlumnoByNumeroControlRef.operationName = 'FindAlumnoByNumeroControl';

export function findAlumnoByNumeroControl(dcOrVars, varsOrOptions, options) {
  
  const { dc: dcInstance, vars: inputVars, options: inputOpts } = validateArgsWithOptions(connectorConfig, dcOrVars, varsOrOptions, options, true, true);
  return executeQuery(findAlumnoByNumeroControlRef(dcInstance, inputVars), inputOpts && { fetchPolicy: inputOpts.fetchPolicy });
}

export const findByCurpNumeroControlRef = (dcOrVars, vars) => {
  const { dc: dcInstance, vars: inputVars} = validateArgs(connectorConfig, dcOrVars, vars);
  dcInstance._useGeneratedSdk();
  return queryRef(dcInstance, 'FindByCurpNumeroControl', inputVars);
}
findByCurpNumeroControlRef.operationName = 'FindByCurpNumeroControl';

export function findByCurpNumeroControl(dcOrVars, varsOrOptions, options) {
  
  const { dc: dcInstance, vars: inputVars, options: inputOpts } = validateArgsWithOptions(connectorConfig, dcOrVars, varsOrOptions, options, true, false);
  return executeQuery(findByCurpNumeroControlRef(dcInstance, inputVars), inputOpts && { fetchPolicy: inputOpts.fetchPolicy });
}

export const getAlumnoRef = (dcOrVars, vars) => {
  const { dc: dcInstance, vars: inputVars} = validateArgs(connectorConfig, dcOrVars, vars, true);
  dcInstance._useGeneratedSdk();
  return queryRef(dcInstance, 'GetAlumno', inputVars);
}
getAlumnoRef.operationName = 'GetAlumno';

export function getAlumno(dcOrVars, varsOrOptions, options) {
  
  const { dc: dcInstance, vars: inputVars, options: inputOpts } = validateArgsWithOptions(connectorConfig, dcOrVars, varsOrOptions, options, true, true);
  return executeQuery(getAlumnoRef(dcInstance, inputVars), inputOpts && { fetchPolicy: inputOpts.fetchPolicy });
}

export const getAlumnoPuiScalarsRef = (dcOrVars, vars) => {
  const { dc: dcInstance, vars: inputVars} = validateArgs(connectorConfig, dcOrVars, vars, true);
  dcInstance._useGeneratedSdk();
  return queryRef(dcInstance, 'GetAlumnoPuiScalars', inputVars);
}
getAlumnoPuiScalarsRef.operationName = 'GetAlumnoPuiScalars';

export function getAlumnoPuiScalars(dcOrVars, varsOrOptions, options) {
  
  const { dc: dcInstance, vars: inputVars, options: inputOpts } = validateArgsWithOptions(connectorConfig, dcOrVars, varsOrOptions, options, true, true);
  return executeQuery(getAlumnoPuiScalarsRef(dcInstance, inputVars), inputOpts && { fetchPolicy: inputOpts.fetchPolicy });
}

export const getAllDataPuiRef = (dcOrVars, vars) => {
  const { dc: dcInstance, vars: inputVars} = validateArgs(connectorConfig, dcOrVars, vars, true);
  dcInstance._useGeneratedSdk();
  return queryRef(dcInstance, 'GetAllDataPUI', inputVars);
}
getAllDataPuiRef.operationName = 'GetAllDataPUI';

export function getAllDataPui(dcOrVars, varsOrOptions, options) {
  
  const { dc: dcInstance, vars: inputVars, options: inputOpts } = validateArgsWithOptions(connectorConfig, dcOrVars, varsOrOptions, options, true, true);
  return executeQuery(getAllDataPuiRef(dcInstance, inputVars), inputOpts && { fetchPolicy: inputOpts.fetchPolicy });
}

export const getAlumnosRef = (dcOrVars, vars) => {
  const { dc: dcInstance, vars: inputVars} = validateArgs(connectorConfig, dcOrVars, vars, true);
  dcInstance._useGeneratedSdk();
  return queryRef(dcInstance, 'GetAlumnos', inputVars);
}
getAlumnosRef.operationName = 'GetAlumnos';

export function getAlumnos(dcOrVars, varsOrOptions, options) {
  
  const { dc: dcInstance, vars: inputVars, options: inputOpts } = validateArgsWithOptions(connectorConfig, dcOrVars, varsOrOptions, options, true, true);
  return executeQuery(getAlumnosRef(dcInstance, inputVars), inputOpts && { fetchPolicy: inputOpts.fetchPolicy });
}

export const getMinumunAlumnoDataRef = (dcOrVars, vars) => {
  const { dc: dcInstance, vars: inputVars} = validateArgs(connectorConfig, dcOrVars, vars, true);
  dcInstance._useGeneratedSdk();
  return queryRef(dcInstance, 'GetMinumunAlumnoData', inputVars);
}
getMinumunAlumnoDataRef.operationName = 'GetMinumunAlumnoData';

export function getMinumunAlumnoData(dcOrVars, varsOrOptions, options) {
  
  const { dc: dcInstance, vars: inputVars, options: inputOpts } = validateArgsWithOptions(connectorConfig, dcOrVars, varsOrOptions, options, true, true);
  return executeQuery(getMinumunAlumnoDataRef(dcInstance, inputVars), inputOpts && { fetchPolicy: inputOpts.fetchPolicy });
}

export const getAlumnosCountRef = (dcOrVars, vars) => {
  const { dc: dcInstance, vars: inputVars} = validateArgs(connectorConfig, dcOrVars, vars, true);
  dcInstance._useGeneratedSdk();
  return queryRef(dcInstance, 'GetAlumnosCount', inputVars);
}
getAlumnosCountRef.operationName = 'GetAlumnosCount';

export function getAlumnosCount(dcOrVars, varsOrOptions, options) {
  
  const { dc: dcInstance, vars: inputVars, options: inputOpts } = validateArgsWithOptions(connectorConfig, dcOrVars, varsOrOptions, options, true, true);
  return executeQuery(getAlumnosCountRef(dcInstance, inputVars), inputOpts && { fetchPolicy: inputOpts.fetchPolicy });
}

export const getAlumnosStatsRef = (dcOrVars, vars) => {
  const { dc: dcInstance, vars: inputVars} = validateArgs(connectorConfig, dcOrVars, vars, true);
  dcInstance._useGeneratedSdk();
  return queryRef(dcInstance, 'GetAlumnosStats', inputVars);
}
getAlumnosStatsRef.operationName = 'GetAlumnosStats';

export function getAlumnosStats(dcOrVars, varsOrOptions, options) {
  
  const { dc: dcInstance, vars: inputVars, options: inputOpts } = validateArgsWithOptions(connectorConfig, dcOrVars, varsOrOptions, options, true, true);
  return executeQuery(getAlumnosStatsRef(dcInstance, inputVars), inputOpts && { fetchPolicy: inputOpts.fetchPolicy });
}

export const getAlumnosBusquedaByNombreRef = (dcOrVars, vars) => {
  const { dc: dcInstance, vars: inputVars} = validateArgs(connectorConfig, dcOrVars, vars, true);
  dcInstance._useGeneratedSdk();
  return queryRef(dcInstance, 'GetAlumnosBusquedaByNombre', inputVars);
}
getAlumnosBusquedaByNombreRef.operationName = 'GetAlumnosBusquedaByNombre';

export function getAlumnosBusquedaByNombre(dcOrVars, varsOrOptions, options) {
  
  const { dc: dcInstance, vars: inputVars, options: inputOpts } = validateArgsWithOptions(connectorConfig, dcOrVars, varsOrOptions, options, true, true);
  return executeQuery(getAlumnosBusquedaByNombreRef(dcInstance, inputVars), inputOpts && { fetchPolicy: inputOpts.fetchPolicy });
}

export const getAlumnosBusquedaByNombreCountRef = (dcOrVars, vars) => {
  const { dc: dcInstance, vars: inputVars} = validateArgs(connectorConfig, dcOrVars, vars, true);
  dcInstance._useGeneratedSdk();
  return queryRef(dcInstance, 'GetAlumnosBusquedaByNombreCount', inputVars);
}
getAlumnosBusquedaByNombreCountRef.operationName = 'GetAlumnosBusquedaByNombreCount';

export function getAlumnosBusquedaByNombreCount(dcOrVars, varsOrOptions, options) {
  
  const { dc: dcInstance, vars: inputVars, options: inputOpts } = validateArgsWithOptions(connectorConfig, dcOrVars, varsOrOptions, options, true, true);
  return executeQuery(getAlumnosBusquedaByNombreCountRef(dcInstance, inputVars), inputOpts && { fetchPolicy: inputOpts.fetchPolicy });
}

export const getAlumnosBusquedaByPrimerApellidoRef = (dcOrVars, vars) => {
  const { dc: dcInstance, vars: inputVars} = validateArgs(connectorConfig, dcOrVars, vars, true);
  dcInstance._useGeneratedSdk();
  return queryRef(dcInstance, 'GetAlumnosBusquedaByPrimerApellido', inputVars);
}
getAlumnosBusquedaByPrimerApellidoRef.operationName = 'GetAlumnosBusquedaByPrimerApellido';

export function getAlumnosBusquedaByPrimerApellido(dcOrVars, varsOrOptions, options) {
  
  const { dc: dcInstance, vars: inputVars, options: inputOpts } = validateArgsWithOptions(connectorConfig, dcOrVars, varsOrOptions, options, true, true);
  return executeQuery(getAlumnosBusquedaByPrimerApellidoRef(dcInstance, inputVars), inputOpts && { fetchPolicy: inputOpts.fetchPolicy });
}

export const getAlumnosBusquedaByPrimerApellidoCountRef = (dcOrVars, vars) => {
  const { dc: dcInstance, vars: inputVars} = validateArgs(connectorConfig, dcOrVars, vars, true);
  dcInstance._useGeneratedSdk();
  return queryRef(dcInstance, 'GetAlumnosBusquedaByPrimerApellidoCount', inputVars);
}
getAlumnosBusquedaByPrimerApellidoCountRef.operationName = 'GetAlumnosBusquedaByPrimerApellidoCount';

export function getAlumnosBusquedaByPrimerApellidoCount(dcOrVars, varsOrOptions, options) {
  
  const { dc: dcInstance, vars: inputVars, options: inputOpts } = validateArgsWithOptions(connectorConfig, dcOrVars, varsOrOptions, options, true, true);
  return executeQuery(getAlumnosBusquedaByPrimerApellidoCountRef(dcInstance, inputVars), inputOpts && { fetchPolicy: inputOpts.fetchPolicy });
}

export const getAlumnosBusquedaByNombreApellidosRef = (dcOrVars, vars) => {
  const { dc: dcInstance, vars: inputVars} = validateArgs(connectorConfig, dcOrVars, vars, true);
  dcInstance._useGeneratedSdk();
  return queryRef(dcInstance, 'GetAlumnosBusquedaByNombreApellidos', inputVars);
}
getAlumnosBusquedaByNombreApellidosRef.operationName = 'GetAlumnosBusquedaByNombreApellidos';

export function getAlumnosBusquedaByNombreApellidos(dcOrVars, varsOrOptions, options) {
  
  const { dc: dcInstance, vars: inputVars, options: inputOpts } = validateArgsWithOptions(connectorConfig, dcOrVars, varsOrOptions, options, true, true);
  return executeQuery(getAlumnosBusquedaByNombreApellidosRef(dcInstance, inputVars), inputOpts && { fetchPolicy: inputOpts.fetchPolicy });
}

export const getAlumnosBusquedaByNombreApellidosCountRef = (dcOrVars, vars) => {
  const { dc: dcInstance, vars: inputVars} = validateArgs(connectorConfig, dcOrVars, vars, true);
  dcInstance._useGeneratedSdk();
  return queryRef(dcInstance, 'GetAlumnosBusquedaByNombreApellidosCount', inputVars);
}
getAlumnosBusquedaByNombreApellidosCountRef.operationName = 'GetAlumnosBusquedaByNombreApellidosCount';

export function getAlumnosBusquedaByNombreApellidosCount(dcOrVars, varsOrOptions, options) {
  
  const { dc: dcInstance, vars: inputVars, options: inputOpts } = validateArgsWithOptions(connectorConfig, dcOrVars, varsOrOptions, options, true, true);
  return executeQuery(getAlumnosBusquedaByNombreApellidosCountRef(dcInstance, inputVars), inputOpts && { fetchPolicy: inputOpts.fetchPolicy });
}

export const getAlumnosByGroupRef = (dcOrVars, vars) => {
  const { dc: dcInstance, vars: inputVars} = validateArgs(connectorConfig, dcOrVars, vars, true);
  dcInstance._useGeneratedSdk();
  return queryRef(dcInstance, 'GetAlumnosByGroup', inputVars);
}
getAlumnosByGroupRef.operationName = 'GetAlumnosByGroup';

export function getAlumnosByGroup(dcOrVars, varsOrOptions, options) {
  
  const { dc: dcInstance, vars: inputVars, options: inputOpts } = validateArgsWithOptions(connectorConfig, dcOrVars, varsOrOptions, options, true, true);
  return executeQuery(getAlumnosByGroupRef(dcInstance, inputVars), inputOpts && { fetchPolicy: inputOpts.fetchPolicy });
}

export const getAlumnosContinuousTrainingRef = (dcOrVars, vars) => {
  const { dc: dcInstance, vars: inputVars} = validateArgs(connectorConfig, dcOrVars, vars, true);
  dcInstance._useGeneratedSdk();
  return queryRef(dcInstance, 'GetAlumnosContinuousTraining', inputVars);
}
getAlumnosContinuousTrainingRef.operationName = 'GetAlumnosContinuousTraining';

export function getAlumnosContinuousTraining(dcOrVars, varsOrOptions, options) {
  
  const { dc: dcInstance, vars: inputVars, options: inputOpts } = validateArgsWithOptions(connectorConfig, dcOrVars, varsOrOptions, options, true, true);
  return executeQuery(getAlumnosContinuousTrainingRef(dcInstance, inputVars), inputOpts && { fetchPolicy: inputOpts.fetchPolicy });
}

export const getAnexo8DataRef = (dcOrVars, vars) => {
  const { dc: dcInstance, vars: inputVars} = validateArgs(connectorConfig, dcOrVars, vars, true);
  dcInstance._useGeneratedSdk();
  return queryRef(dcInstance, 'GetAnexo8Data', inputVars);
}
getAnexo8DataRef.operationName = 'GetAnexo8Data';

export function getAnexo8Data(dcOrVars, varsOrOptions, options) {
  
  const { dc: dcInstance, vars: inputVars, options: inputOpts } = validateArgsWithOptions(connectorConfig, dcOrVars, varsOrOptions, options, true, true);
  return executeQuery(getAnexo8DataRef(dcInstance, inputVars), inputOpts && { fetchPolicy: inputOpts.fetchPolicy });
}

export const getAsignaturasOnlyRef = (dcOrVars, vars) => {
  const { dc: dcInstance, vars: inputVars} = validateArgs(connectorConfig, dcOrVars, vars, true);
  dcInstance._useGeneratedSdk();
  return queryRef(dcInstance, 'GetAsignaturasOnly', inputVars);
}
getAsignaturasOnlyRef.operationName = 'GetAsignaturasOnly';

export function getAsignaturasOnly(dcOrVars, varsOrOptions, options) {
  
  const { dc: dcInstance, vars: inputVars, options: inputOpts } = validateArgsWithOptions(connectorConfig, dcOrVars, varsOrOptions, options, true, true);
  return executeQuery(getAsignaturasOnlyRef(dcInstance, inputVars), inputOpts && { fetchPolicy: inputOpts.fetchPolicy });
}

export const getAsignaturasOnlyByIdAsignaturaRef = (dcOrVars, vars) => {
  const { dc: dcInstance, vars: inputVars} = validateArgs(connectorConfig, dcOrVars, vars, true);
  dcInstance._useGeneratedSdk();
  return queryRef(dcInstance, 'GetAsignaturasOnlyByIdAsignatura', inputVars);
}
getAsignaturasOnlyByIdAsignaturaRef.operationName = 'GetAsignaturasOnlyByIdAsignatura';

export function getAsignaturasOnlyByIdAsignatura(dcOrVars, varsOrOptions, options) {
  
  const { dc: dcInstance, vars: inputVars, options: inputOpts } = validateArgsWithOptions(connectorConfig, dcOrVars, varsOrOptions, options, true, true);
  return executeQuery(getAsignaturasOnlyByIdAsignaturaRef(dcInstance, inputVars), inputOpts && { fetchPolicy: inputOpts.fetchPolicy });
}

export const getBitacoraRef = (dcOrVars, vars) => {
  const { dc: dcInstance, vars: inputVars} = validateArgs(connectorConfig, dcOrVars, vars, true);
  dcInstance._useGeneratedSdk();
  return queryRef(dcInstance, 'GetBitacora', inputVars);
}
getBitacoraRef.operationName = 'GetBitacora';

export function getBitacora(dcOrVars, varsOrOptions, options) {
  
  const { dc: dcInstance, vars: inputVars, options: inputOpts } = validateArgsWithOptions(connectorConfig, dcOrVars, varsOrOptions, options, true, true);
  return executeQuery(getBitacoraRef(dcInstance, inputVars), inputOpts && { fetchPolicy: inputOpts.fetchPolicy });
}

export const getBitacoraCountRef = (dcOrVars, vars) => {
  const { dc: dcInstance, vars: inputVars} = validateArgs(connectorConfig, dcOrVars, vars, true);
  dcInstance._useGeneratedSdk();
  return queryRef(dcInstance, 'GetBitacoraCount', inputVars);
}
getBitacoraCountRef.operationName = 'GetBitacoraCount';

export function getBitacoraCount(dcOrVars, varsOrOptions, options) {
  
  const { dc: dcInstance, vars: inputVars, options: inputOpts } = validateArgsWithOptions(connectorConfig, dcOrVars, varsOrOptions, options, true, true);
  return executeQuery(getBitacoraCountRef(dcInstance, inputVars), inputOpts && { fetchPolicy: inputOpts.fetchPolicy });
}

export const getBitacoraByModuloRef = (dcOrVars, vars) => {
  const { dc: dcInstance, vars: inputVars} = validateArgs(connectorConfig, dcOrVars, vars, true);
  dcInstance._useGeneratedSdk();
  return queryRef(dcInstance, 'GetBitacoraByModulo', inputVars);
}
getBitacoraByModuloRef.operationName = 'GetBitacoraByModulo';

export function getBitacoraByModulo(dcOrVars, varsOrOptions, options) {
  
  const { dc: dcInstance, vars: inputVars, options: inputOpts } = validateArgsWithOptions(connectorConfig, dcOrVars, varsOrOptions, options, true, true);
  return executeQuery(getBitacoraByModuloRef(dcInstance, inputVars), inputOpts && { fetchPolicy: inputOpts.fetchPolicy });
}

export const getBitacoraByModuloCountRef = (dcOrVars, vars) => {
  const { dc: dcInstance, vars: inputVars} = validateArgs(connectorConfig, dcOrVars, vars, true);
  dcInstance._useGeneratedSdk();
  return queryRef(dcInstance, 'GetBitacoraByModuloCount', inputVars);
}
getBitacoraByModuloCountRef.operationName = 'GetBitacoraByModuloCount';

export function getBitacoraByModuloCount(dcOrVars, varsOrOptions, options) {
  
  const { dc: dcInstance, vars: inputVars, options: inputOpts } = validateArgsWithOptions(connectorConfig, dcOrVars, varsOrOptions, options, true, true);
  return executeQuery(getBitacoraByModuloCountRef(dcInstance, inputVars), inputOpts && { fetchPolicy: inputOpts.fetchPolicy });
}

export const getBitacoraByUsuarioRef = (dcOrVars, vars) => {
  const { dc: dcInstance, vars: inputVars} = validateArgs(connectorConfig, dcOrVars, vars, true);
  dcInstance._useGeneratedSdk();
  return queryRef(dcInstance, 'GetBitacoraByUsuario', inputVars);
}
getBitacoraByUsuarioRef.operationName = 'GetBitacoraByUsuario';

export function getBitacoraByUsuario(dcOrVars, varsOrOptions, options) {
  
  const { dc: dcInstance, vars: inputVars, options: inputOpts } = validateArgsWithOptions(connectorConfig, dcOrVars, varsOrOptions, options, true, true);
  return executeQuery(getBitacoraByUsuarioRef(dcInstance, inputVars), inputOpts && { fetchPolicy: inputOpts.fetchPolicy });
}

export const getBitacoraByUsuarioCountRef = (dcOrVars, vars) => {
  const { dc: dcInstance, vars: inputVars} = validateArgs(connectorConfig, dcOrVars, vars, true);
  dcInstance._useGeneratedSdk();
  return queryRef(dcInstance, 'GetBitacoraByUsuarioCount', inputVars);
}
getBitacoraByUsuarioCountRef.operationName = 'GetBitacoraByUsuarioCount';

export function getBitacoraByUsuarioCount(dcOrVars, varsOrOptions, options) {
  
  const { dc: dcInstance, vars: inputVars, options: inputOpts } = validateArgsWithOptions(connectorConfig, dcOrVars, varsOrOptions, options, true, true);
  return executeQuery(getBitacoraByUsuarioCountRef(dcInstance, inputVars), inputOpts && { fetchPolicy: inputOpts.fetchPolicy });
}

export const getBitacoraByModuloUsuarioRef = (dcOrVars, vars) => {
  const { dc: dcInstance, vars: inputVars} = validateArgs(connectorConfig, dcOrVars, vars, true);
  dcInstance._useGeneratedSdk();
  return queryRef(dcInstance, 'GetBitacoraByModuloUsuario', inputVars);
}
getBitacoraByModuloUsuarioRef.operationName = 'GetBitacoraByModuloUsuario';

export function getBitacoraByModuloUsuario(dcOrVars, varsOrOptions, options) {
  
  const { dc: dcInstance, vars: inputVars, options: inputOpts } = validateArgsWithOptions(connectorConfig, dcOrVars, varsOrOptions, options, true, true);
  return executeQuery(getBitacoraByModuloUsuarioRef(dcInstance, inputVars), inputOpts && { fetchPolicy: inputOpts.fetchPolicy });
}

export const getBitacoraByModuloUsuarioCountRef = (dcOrVars, vars) => {
  const { dc: dcInstance, vars: inputVars} = validateArgs(connectorConfig, dcOrVars, vars, true);
  dcInstance._useGeneratedSdk();
  return queryRef(dcInstance, 'GetBitacoraByModuloUsuarioCount', inputVars);
}
getBitacoraByModuloUsuarioCountRef.operationName = 'GetBitacoraByModuloUsuarioCount';

export function getBitacoraByModuloUsuarioCount(dcOrVars, varsOrOptions, options) {
  
  const { dc: dcInstance, vars: inputVars, options: inputOpts } = validateArgsWithOptions(connectorConfig, dcOrVars, varsOrOptions, options, true, true);
  return executeQuery(getBitacoraByModuloUsuarioCountRef(dcInstance, inputVars), inputOpts && { fetchPolicy: inputOpts.fetchPolicy });
}

export const getBitacoraModulosRef = (dcOrVars, vars) => {
  const { dc: dcInstance, vars: inputVars} = validateArgs(connectorConfig, dcOrVars, vars, true);
  dcInstance._useGeneratedSdk();
  return queryRef(dcInstance, 'GetBitacoraModulos', inputVars);
}
getBitacoraModulosRef.operationName = 'GetBitacoraModulos';

export function getBitacoraModulos(dcOrVars, varsOrOptions, options) {
  
  const { dc: dcInstance, vars: inputVars, options: inputOpts } = validateArgsWithOptions(connectorConfig, dcOrVars, varsOrOptions, options, true, true);
  return executeQuery(getBitacoraModulosRef(dcInstance, inputVars), inputOpts && { fetchPolicy: inputOpts.fetchPolicy });
}

export const getBitacoraByTypeRef = (dcOrVars, vars) => {
  const { dc: dcInstance, vars: inputVars} = validateArgs(connectorConfig, dcOrVars, vars, true);
  dcInstance._useGeneratedSdk();
  return queryRef(dcInstance, 'GetBitacoraByType', inputVars);
}
getBitacoraByTypeRef.operationName = 'GetBitacoraByType';

export function getBitacoraByType(dcOrVars, varsOrOptions, options) {
  
  const { dc: dcInstance, vars: inputVars, options: inputOpts } = validateArgsWithOptions(connectorConfig, dcOrVars, varsOrOptions, options, true, true);
  return executeQuery(getBitacoraByTypeRef(dcInstance, inputVars), inputOpts && { fetchPolicy: inputOpts.fetchPolicy });
}

export const getBitacoraByTypeCountRef = (dcOrVars, vars) => {
  const { dc: dcInstance, vars: inputVars} = validateArgs(connectorConfig, dcOrVars, vars, true);
  dcInstance._useGeneratedSdk();
  return queryRef(dcInstance, 'GetBitacoraByTypeCount', inputVars);
}
getBitacoraByTypeCountRef.operationName = 'GetBitacoraByTypeCount';

export function getBitacoraByTypeCount(dcOrVars, varsOrOptions, options) {
  
  const { dc: dcInstance, vars: inputVars, options: inputOpts } = validateArgsWithOptions(connectorConfig, dcOrVars, varsOrOptions, options, true, true);
  return executeQuery(getBitacoraByTypeCountRef(dcInstance, inputVars), inputOpts && { fetchPolicy: inputOpts.fetchPolicy });
}

export const getBitacoraByTypeModuloRef = (dcOrVars, vars) => {
  const { dc: dcInstance, vars: inputVars} = validateArgs(connectorConfig, dcOrVars, vars, true);
  dcInstance._useGeneratedSdk();
  return queryRef(dcInstance, 'GetBitacoraByTypeModulo', inputVars);
}
getBitacoraByTypeModuloRef.operationName = 'GetBitacoraByTypeModulo';

export function getBitacoraByTypeModulo(dcOrVars, varsOrOptions, options) {
  
  const { dc: dcInstance, vars: inputVars, options: inputOpts } = validateArgsWithOptions(connectorConfig, dcOrVars, varsOrOptions, options, true, true);
  return executeQuery(getBitacoraByTypeModuloRef(dcInstance, inputVars), inputOpts && { fetchPolicy: inputOpts.fetchPolicy });
}

export const getBitacoraByTypeModuloCountRef = (dcOrVars, vars) => {
  const { dc: dcInstance, vars: inputVars} = validateArgs(connectorConfig, dcOrVars, vars, true);
  dcInstance._useGeneratedSdk();
  return queryRef(dcInstance, 'GetBitacoraByTypeModuloCount', inputVars);
}
getBitacoraByTypeModuloCountRef.operationName = 'GetBitacoraByTypeModuloCount';

export function getBitacoraByTypeModuloCount(dcOrVars, varsOrOptions, options) {
  
  const { dc: dcInstance, vars: inputVars, options: inputOpts } = validateArgsWithOptions(connectorConfig, dcOrVars, varsOrOptions, options, true, true);
  return executeQuery(getBitacoraByTypeModuloCountRef(dcInstance, inputVars), inputOpts && { fetchPolicy: inputOpts.fetchPolicy });
}

export const getBitacoraByTypeUsuarioRef = (dcOrVars, vars) => {
  const { dc: dcInstance, vars: inputVars} = validateArgs(connectorConfig, dcOrVars, vars, true);
  dcInstance._useGeneratedSdk();
  return queryRef(dcInstance, 'GetBitacoraByTypeUsuario', inputVars);
}
getBitacoraByTypeUsuarioRef.operationName = 'GetBitacoraByTypeUsuario';

export function getBitacoraByTypeUsuario(dcOrVars, varsOrOptions, options) {
  
  const { dc: dcInstance, vars: inputVars, options: inputOpts } = validateArgsWithOptions(connectorConfig, dcOrVars, varsOrOptions, options, true, true);
  return executeQuery(getBitacoraByTypeUsuarioRef(dcInstance, inputVars), inputOpts && { fetchPolicy: inputOpts.fetchPolicy });
}

export const getBitacoraByTypeUsuarioCountRef = (dcOrVars, vars) => {
  const { dc: dcInstance, vars: inputVars} = validateArgs(connectorConfig, dcOrVars, vars, true);
  dcInstance._useGeneratedSdk();
  return queryRef(dcInstance, 'GetBitacoraByTypeUsuarioCount', inputVars);
}
getBitacoraByTypeUsuarioCountRef.operationName = 'GetBitacoraByTypeUsuarioCount';

export function getBitacoraByTypeUsuarioCount(dcOrVars, varsOrOptions, options) {
  
  const { dc: dcInstance, vars: inputVars, options: inputOpts } = validateArgsWithOptions(connectorConfig, dcOrVars, varsOrOptions, options, true, true);
  return executeQuery(getBitacoraByTypeUsuarioCountRef(dcInstance, inputVars), inputOpts && { fetchPolicy: inputOpts.fetchPolicy });
}

export const getBitacoraByTypeModuloUsuarioRef = (dcOrVars, vars) => {
  const { dc: dcInstance, vars: inputVars} = validateArgs(connectorConfig, dcOrVars, vars, true);
  dcInstance._useGeneratedSdk();
  return queryRef(dcInstance, 'GetBitacoraByTypeModuloUsuario', inputVars);
}
getBitacoraByTypeModuloUsuarioRef.operationName = 'GetBitacoraByTypeModuloUsuario';

export function getBitacoraByTypeModuloUsuario(dcOrVars, varsOrOptions, options) {
  
  const { dc: dcInstance, vars: inputVars, options: inputOpts } = validateArgsWithOptions(connectorConfig, dcOrVars, varsOrOptions, options, true, true);
  return executeQuery(getBitacoraByTypeModuloUsuarioRef(dcInstance, inputVars), inputOpts && { fetchPolicy: inputOpts.fetchPolicy });
}

export const getBitacoraByTypeModuloUsuarioCountRef = (dcOrVars, vars) => {
  const { dc: dcInstance, vars: inputVars} = validateArgs(connectorConfig, dcOrVars, vars, true);
  dcInstance._useGeneratedSdk();
  return queryRef(dcInstance, 'GetBitacoraByTypeModuloUsuarioCount', inputVars);
}
getBitacoraByTypeModuloUsuarioCountRef.operationName = 'GetBitacoraByTypeModuloUsuarioCount';

export function getBitacoraByTypeModuloUsuarioCount(dcOrVars, varsOrOptions, options) {
  
  const { dc: dcInstance, vars: inputVars, options: inputOpts } = validateArgsWithOptions(connectorConfig, dcOrVars, varsOrOptions, options, true, true);
  return executeQuery(getBitacoraByTypeModuloUsuarioCountRef(dcInstance, inputVars), inputOpts && { fetchPolicy: inputOpts.fetchPolicy });
}

export const getBitacoraByTypeModulosRef = (dcOrVars, vars) => {
  const { dc: dcInstance, vars: inputVars} = validateArgs(connectorConfig, dcOrVars, vars, true);
  dcInstance._useGeneratedSdk();
  return queryRef(dcInstance, 'GetBitacoraByTypeModulos', inputVars);
}
getBitacoraByTypeModulosRef.operationName = 'GetBitacoraByTypeModulos';

export function getBitacoraByTypeModulos(dcOrVars, varsOrOptions, options) {
  
  const { dc: dcInstance, vars: inputVars, options: inputOpts } = validateArgsWithOptions(connectorConfig, dcOrVars, varsOrOptions, options, true, true);
  return executeQuery(getBitacoraByTypeModulosRef(dcInstance, inputVars), inputOpts && { fetchPolicy: inputOpts.fetchPolicy });
}

export const getCarreraRvoeByAlumnoRef = (dcOrVars, vars) => {
  const { dc: dcInstance, vars: inputVars} = validateArgs(connectorConfig, dcOrVars, vars, true);
  dcInstance._useGeneratedSdk();
  return queryRef(dcInstance, 'GetCarreraRvoeByAlumno', inputVars);
}
getCarreraRvoeByAlumnoRef.operationName = 'GetCarreraRvoeByAlumno';

export function getCarreraRvoeByAlumno(dcOrVars, varsOrOptions, options) {
  
  const { dc: dcInstance, vars: inputVars, options: inputOpts } = validateArgsWithOptions(connectorConfig, dcOrVars, varsOrOptions, options, true, true);
  return executeQuery(getCarreraRvoeByAlumnoRef(dcInstance, inputVars), inputOpts && { fetchPolicy: inputOpts.fetchPolicy });
}

export const getContinousTrainingRef = (dcOrVars, vars) => {
  const { dc: dcInstance, vars: inputVars} = validateArgs(connectorConfig, dcOrVars, vars, true);
  dcInstance._useGeneratedSdk();
  return queryRef(dcInstance, 'GetContinousTraining', inputVars);
}
getContinousTrainingRef.operationName = 'GetContinousTraining';

export function getContinousTraining(dcOrVars, varsOrOptions, options) {
  
  const { dc: dcInstance, vars: inputVars, options: inputOpts } = validateArgsWithOptions(connectorConfig, dcOrVars, varsOrOptions, options, true, true);
  return executeQuery(getContinousTrainingRef(dcInstance, inputVars), inputOpts && { fetchPolicy: inputOpts.fetchPolicy });
}

export const getDegreeCertificateByCarreraRef = (dcOrVars, vars) => {
  const { dc: dcInstance, vars: inputVars} = validateArgs(connectorConfig, dcOrVars, vars, true);
  dcInstance._useGeneratedSdk();
  return queryRef(dcInstance, 'GetDegreeCertificateByCarrera', inputVars);
}
getDegreeCertificateByCarreraRef.operationName = 'GetDegreeCertificateByCarrera';

export function getDegreeCertificateByCarrera(dcOrVars, varsOrOptions, options) {
  
  const { dc: dcInstance, vars: inputVars, options: inputOpts } = validateArgsWithOptions(connectorConfig, dcOrVars, varsOrOptions, options, true, true);
  return executeQuery(getDegreeCertificateByCarreraRef(dcInstance, inputVars), inputOpts && { fetchPolicy: inputOpts.fetchPolicy });
}

export const getFullAlumnoRef = (dcOrVars, vars) => {
  const { dc: dcInstance, vars: inputVars} = validateArgs(connectorConfig, dcOrVars, vars, true);
  dcInstance._useGeneratedSdk();
  return queryRef(dcInstance, 'GetFullAlumno', inputVars);
}
getFullAlumnoRef.operationName = 'GetFullAlumno';

export function getFullAlumno(dcOrVars, varsOrOptions, options) {
  
  const { dc: dcInstance, vars: inputVars, options: inputOpts } = validateArgsWithOptions(connectorConfig, dcOrVars, varsOrOptions, options, true, true);
  return executeQuery(getFullAlumnoRef(dcInstance, inputVars), inputOpts && { fetchPolicy: inputOpts.fetchPolicy });
}

export const getFullAlumnoTrainingRef = (dcOrVars, vars) => {
  const { dc: dcInstance, vars: inputVars} = validateArgs(connectorConfig, dcOrVars, vars, true);
  dcInstance._useGeneratedSdk();
  return queryRef(dcInstance, 'GetFullAlumnoTraining', inputVars);
}
getFullAlumnoTrainingRef.operationName = 'GetFullAlumnoTraining';

export function getFullAlumnoTraining(dcOrVars, varsOrOptions, options) {
  
  const { dc: dcInstance, vars: inputVars, options: inputOpts } = validateArgsWithOptions(connectorConfig, dcOrVars, varsOrOptions, options, true, true);
  return executeQuery(getFullAlumnoTrainingRef(dcInstance, inputVars), inputOpts && { fetchPolicy: inputOpts.fetchPolicy });
}

export const getInstitucionPuiRef = (dcOrVars, vars) => {
  const { dc: dcInstance, vars: inputVars} = validateArgs(connectorConfig, dcOrVars, vars, true);
  dcInstance._useGeneratedSdk();
  return queryRef(dcInstance, 'GetInstitucionPui', inputVars);
}
getInstitucionPuiRef.operationName = 'GetInstitucionPui';

export function getInstitucionPui(dcOrVars, varsOrOptions, options) {
  
  const { dc: dcInstance, vars: inputVars, options: inputOpts } = validateArgsWithOptions(connectorConfig, dcOrVars, varsOrOptions, options, true, true);
  return executeQuery(getInstitucionPuiRef(dcInstance, inputVars), inputOpts && { fetchPolicy: inputOpts.fetchPolicy });
}

export const updateCarreraPuiRef = (dcOrVars, vars) => {
  const { dc: dcInstance, vars: inputVars} = validateArgs(connectorConfig, dcOrVars, vars, true);
  dcInstance._useGeneratedSdk();
  return mutationRef(dcInstance, 'UpdateCarreraPui', inputVars);
}
updateCarreraPuiRef.operationName = 'UpdateCarreraPui';

export function updateCarreraPui(dcOrVars, vars) {
  const { dc: dcInstance, vars: inputVars } = validateArgs(connectorConfig, dcOrVars, vars, true);
  return executeMutation(updateCarreraPuiRef(dcInstance, inputVars));
}

export const getLastAlumnoAsignaturaGrupoIdRef = (dc) => {
  const { dc: dcInstance} = validateArgs(connectorConfig, dc, undefined);
  dcInstance._useGeneratedSdk();
  return queryRef(dcInstance, 'GetLastAlumnoAsignaturaGrupoId');
}
getLastAlumnoAsignaturaGrupoIdRef.operationName = 'GetLastAlumnoAsignaturaGrupoId';

export function getLastAlumnoAsignaturaGrupoId(dcOrOptions, options) {
  
  const { dc: dcInstance, vars: inputVars, options: inputOpts } = validateArgsWithOptions(connectorConfig, dcOrOptions, options, undefined,false, false);
  return executeQuery(getLastAlumnoAsignaturaGrupoIdRef(dcInstance, inputVars), inputOpts && { fetchPolicy: inputOpts.fetchPolicy });
}

export const getLastAlumnoAsignaturaIdRef = (dc) => {
  const { dc: dcInstance} = validateArgs(connectorConfig, dc, undefined);
  dcInstance._useGeneratedSdk();
  return queryRef(dcInstance, 'GetLastAlumnoAsignaturaId');
}
getLastAlumnoAsignaturaIdRef.operationName = 'GetLastAlumnoAsignaturaId';

export function getLastAlumnoAsignaturaId(dcOrOptions, options) {
  
  const { dc: dcInstance, vars: inputVars, options: inputOpts } = validateArgsWithOptions(connectorConfig, dcOrOptions, options, undefined,false, false);
  return executeQuery(getLastAlumnoAsignaturaIdRef(dcInstance, inputVars), inputOpts && { fetchPolicy: inputOpts.fetchPolicy });
}

export const getPlanDataInstitutionRef = (dcOrVars, vars) => {
  const { dc: dcInstance, vars: inputVars} = validateArgs(connectorConfig, dcOrVars, vars, true);
  dcInstance._useGeneratedSdk();
  return queryRef(dcInstance, 'GetPlanDataInstitution', inputVars);
}
getPlanDataInstitutionRef.operationName = 'GetPlanDataInstitution';

export function getPlanDataInstitution(dcOrVars, varsOrOptions, options) {
  
  const { dc: dcInstance, vars: inputVars, options: inputOpts } = validateArgsWithOptions(connectorConfig, dcOrVars, varsOrOptions, options, true, true);
  return executeQuery(getPlanDataInstitutionRef(dcInstance, inputVars), inputOpts && { fetchPolicy: inputOpts.fetchPolicy });
}

export const insertAlumnoAsignaturaGrupoRef = (dcOrVars, vars) => {
  const { dc: dcInstance, vars: inputVars} = validateArgs(connectorConfig, dcOrVars, vars, true);
  dcInstance._useGeneratedSdk();
  return mutationRef(dcInstance, 'InsertAlumnoAsignaturaGrupo', inputVars);
}
insertAlumnoAsignaturaGrupoRef.operationName = 'InsertAlumnoAsignaturaGrupo';

export function insertAlumnoAsignaturaGrupo(dcOrVars, vars) {
  const { dc: dcInstance, vars: inputVars } = validateArgs(connectorConfig, dcOrVars, vars, true);
  return executeMutation(insertAlumnoAsignaturaGrupoRef(dcInstance, inputVars));
}

export const updateAlumnoAsignaturaGrupoRef = (dcOrVars, vars) => {
  const { dc: dcInstance, vars: inputVars} = validateArgs(connectorConfig, dcOrVars, vars, true);
  dcInstance._useGeneratedSdk();
  return mutationRef(dcInstance, 'UpdateAlumnoAsignaturaGrupo', inputVars);
}
updateAlumnoAsignaturaGrupoRef.operationName = 'UpdateAlumnoAsignaturaGrupo';

export function updateAlumnoAsignaturaGrupo(dcOrVars, vars) {
  const { dc: dcInstance, vars: inputVars } = validateArgs(connectorConfig, dcOrVars, vars, true);
  return executeMutation(updateAlumnoAsignaturaGrupoRef(dcInstance, inputVars));
}

export const insertAlumnoAsignaturaRef = (dcOrVars, vars) => {
  const { dc: dcInstance, vars: inputVars} = validateArgs(connectorConfig, dcOrVars, vars, true);
  dcInstance._useGeneratedSdk();
  return mutationRef(dcInstance, 'InsertAlumnoAsignatura', inputVars);
}
insertAlumnoAsignaturaRef.operationName = 'InsertAlumnoAsignatura';

export function insertAlumnoAsignatura(dcOrVars, vars) {
  const { dc: dcInstance, vars: inputVars } = validateArgs(connectorConfig, dcOrVars, vars, true);
  return executeMutation(insertAlumnoAsignaturaRef(dcInstance, inputVars));
}

export const updateAlumnoAsignaturaRef = (dcOrVars, vars) => {
  const { dc: dcInstance, vars: inputVars} = validateArgs(connectorConfig, dcOrVars, vars, true);
  dcInstance._useGeneratedSdk();
  return mutationRef(dcInstance, 'UpdateAlumnoAsignatura', inputVars);
}
updateAlumnoAsignaturaRef.operationName = 'UpdateAlumnoAsignatura';

export function updateAlumnoAsignatura(dcOrVars, vars) {
  const { dc: dcInstance, vars: inputVars } = validateArgs(connectorConfig, dcOrVars, vars, true);
  return executeMutation(updateAlumnoAsignaturaRef(dcInstance, inputVars));
}

export const updateAlumnoAsignaturaCalificacionRef = (dcOrVars, vars) => {
  const { dc: dcInstance, vars: inputVars} = validateArgs(connectorConfig, dcOrVars, vars, true);
  dcInstance._useGeneratedSdk();
  return mutationRef(dcInstance, 'UpdateAlumnoAsignaturaCalificacion', inputVars);
}
updateAlumnoAsignaturaCalificacionRef.operationName = 'UpdateAlumnoAsignaturaCalificacion';

export function updateAlumnoAsignaturaCalificacion(dcOrVars, vars) {
  const { dc: dcInstance, vars: inputVars } = validateArgs(connectorConfig, dcOrVars, vars, true);
  return executeMutation(updateAlumnoAsignaturaCalificacionRef(dcInstance, inputVars));
}

export const deleteAlumnoAsignaturaRef = (dcOrVars, vars) => {
  const { dc: dcInstance, vars: inputVars} = validateArgs(connectorConfig, dcOrVars, vars, true);
  dcInstance._useGeneratedSdk();
  return mutationRef(dcInstance, 'DeleteAlumnoAsignatura', inputVars);
}
deleteAlumnoAsignaturaRef.operationName = 'DeleteAlumnoAsignatura';

export function deleteAlumnoAsignatura(dcOrVars, vars) {
  const { dc: dcInstance, vars: inputVars } = validateArgs(connectorConfig, dcOrVars, vars, true);
  return executeMutation(deleteAlumnoAsignaturaRef(dcInstance, inputVars));
}

export const deleteAlumnoAsignaturaGrupoRef = (dcOrVars, vars) => {
  const { dc: dcInstance, vars: inputVars} = validateArgs(connectorConfig, dcOrVars, vars, true);
  dcInstance._useGeneratedSdk();
  return mutationRef(dcInstance, 'DeleteAlumnoAsignaturaGrupo', inputVars);
}
deleteAlumnoAsignaturaGrupoRef.operationName = 'DeleteAlumnoAsignaturaGrupo';

export function deleteAlumnoAsignaturaGrupo(dcOrVars, vars) {
  const { dc: dcInstance, vars: inputVars } = validateArgs(connectorConfig, dcOrVars, vars, true);
  return executeMutation(deleteAlumnoAsignaturaGrupoRef(dcInstance, inputVars));
}

export const insertAlumnoCarreraRef = (dcOrVars, vars) => {
  const { dc: dcInstance, vars: inputVars} = validateArgs(connectorConfig, dcOrVars, vars, true);
  dcInstance._useGeneratedSdk();
  return mutationRef(dcInstance, 'InsertAlumnoCarrera', inputVars);
}
insertAlumnoCarreraRef.operationName = 'InsertAlumnoCarrera';

export function insertAlumnoCarrera(dcOrVars, vars) {
  const { dc: dcInstance, vars: inputVars } = validateArgs(connectorConfig, dcOrVars, vars, true);
  return executeMutation(insertAlumnoCarreraRef(dcInstance, inputVars));
}

export const updateAlumnoCarreraRef = (dcOrVars, vars) => {
  const { dc: dcInstance, vars: inputVars} = validateArgs(connectorConfig, dcOrVars, vars, true);
  dcInstance._useGeneratedSdk();
  return mutationRef(dcInstance, 'UpdateAlumnoCarrera', inputVars);
}
updateAlumnoCarreraRef.operationName = 'UpdateAlumnoCarrera';

export function updateAlumnoCarrera(dcOrVars, vars) {
  const { dc: dcInstance, vars: inputVars } = validateArgs(connectorConfig, dcOrVars, vars, true);
  return executeMutation(updateAlumnoCarreraRef(dcInstance, inputVars));
}

export const linkAlumnoCarreraDegreeRef = (dcOrVars, vars) => {
  const { dc: dcInstance, vars: inputVars} = validateArgs(connectorConfig, dcOrVars, vars, true);
  dcInstance._useGeneratedSdk();
  return mutationRef(dcInstance, 'LinkAlumnoCarreraDegree', inputVars);
}
linkAlumnoCarreraDegreeRef.operationName = 'LinkAlumnoCarreraDegree';

export function linkAlumnoCarreraDegree(dcOrVars, vars) {
  const { dc: dcInstance, vars: inputVars } = validateArgs(connectorConfig, dcOrVars, vars, true);
  return executeMutation(linkAlumnoCarreraDegreeRef(dcInstance, inputVars));
}

export const linkAlumnoCarreraCertificateRef = (dcOrVars, vars) => {
  const { dc: dcInstance, vars: inputVars} = validateArgs(connectorConfig, dcOrVars, vars, true);
  dcInstance._useGeneratedSdk();
  return mutationRef(dcInstance, 'LinkAlumnoCarreraCertificate', inputVars);
}
linkAlumnoCarreraCertificateRef.operationName = 'LinkAlumnoCarreraCertificate';

export function linkAlumnoCarreraCertificate(dcOrVars, vars) {
  const { dc: dcInstance, vars: inputVars } = validateArgs(connectorConfig, dcOrVars, vars, true);
  return executeMutation(linkAlumnoCarreraCertificateRef(dcInstance, inputVars));
}

export const insertDegreeCareerRef = (dcOrVars, vars) => {
  const { dc: dcInstance, vars: inputVars} = validateArgs(connectorConfig, dcOrVars, vars, true);
  dcInstance._useGeneratedSdk();
  return mutationRef(dcInstance, 'InsertDegreeCareer', inputVars);
}
insertDegreeCareerRef.operationName = 'InsertDegreeCareer';

export function insertDegreeCareer(dcOrVars, vars) {
  const { dc: dcInstance, vars: inputVars } = validateArgs(connectorConfig, dcOrVars, vars, true);
  return executeMutation(insertDegreeCareerRef(dcInstance, inputVars));
}

export const updateDegreeCareerRef = (dcOrVars, vars) => {
  const { dc: dcInstance, vars: inputVars} = validateArgs(connectorConfig, dcOrVars, vars, true);
  dcInstance._useGeneratedSdk();
  return mutationRef(dcInstance, 'UpdateDegreeCareer', inputVars);
}
updateDegreeCareerRef.operationName = 'UpdateDegreeCareer';

export function updateDegreeCareer(dcOrVars, vars) {
  const { dc: dcInstance, vars: inputVars } = validateArgs(connectorConfig, dcOrVars, vars, true);
  return executeMutation(updateDegreeCareerRef(dcInstance, inputVars));
}

export const insertCertificateCareerRef = (dcOrVars, vars) => {
  const { dc: dcInstance, vars: inputVars} = validateArgs(connectorConfig, dcOrVars, vars, true);
  dcInstance._useGeneratedSdk();
  return mutationRef(dcInstance, 'InsertCertificateCareer', inputVars);
}
insertCertificateCareerRef.operationName = 'InsertCertificateCareer';

export function insertCertificateCareer(dcOrVars, vars) {
  const { dc: dcInstance, vars: inputVars } = validateArgs(connectorConfig, dcOrVars, vars, true);
  return executeMutation(insertCertificateCareerRef(dcInstance, inputVars));
}

export const updateCertificateCareerRef = (dcOrVars, vars) => {
  const { dc: dcInstance, vars: inputVars} = validateArgs(connectorConfig, dcOrVars, vars, true);
  dcInstance._useGeneratedSdk();
  return mutationRef(dcInstance, 'UpdateCertificateCareer', inputVars);
}
updateCertificateCareerRef.operationName = 'UpdateCertificateCareer';

export function updateCertificateCareer(dcOrVars, vars) {
  const { dc: dcInstance, vars: inputVars } = validateArgs(connectorConfig, dcOrVars, vars, true);
  return executeMutation(updateCertificateCareerRef(dcInstance, inputVars));
}

export const insertAlumnoRvoeRef = (dcOrVars, vars) => {
  const { dc: dcInstance, vars: inputVars} = validateArgs(connectorConfig, dcOrVars, vars, true);
  dcInstance._useGeneratedSdk();
  return mutationRef(dcInstance, 'InsertAlumnoRvoe', inputVars);
}
insertAlumnoRvoeRef.operationName = 'InsertAlumnoRvoe';

export function insertAlumnoRvoe(dcOrVars, vars) {
  const { dc: dcInstance, vars: inputVars } = validateArgs(connectorConfig, dcOrVars, vars, true);
  return executeMutation(insertAlumnoRvoeRef(dcInstance, inputVars));
}

export const updateAlumnoRvoeRef = (dcOrVars, vars) => {
  const { dc: dcInstance, vars: inputVars} = validateArgs(connectorConfig, dcOrVars, vars, true);
  dcInstance._useGeneratedSdk();
  return mutationRef(dcInstance, 'UpdateAlumnoRvoe', inputVars);
}
updateAlumnoRvoeRef.operationName = 'UpdateAlumnoRvoe';

export function updateAlumnoRvoe(dcOrVars, vars) {
  const { dc: dcInstance, vars: inputVars } = validateArgs(connectorConfig, dcOrVars, vars, true);
  return executeMutation(updateAlumnoRvoeRef(dcInstance, inputVars));
}

export const addComponenteRef = (dcOrVars, vars) => {
  const { dc: dcInstance, vars: inputVars} = validateArgs(connectorConfig, dcOrVars, vars, true);
  dcInstance._useGeneratedSdk();
  return mutationRef(dcInstance, 'AddComponente', inputVars);
}
addComponenteRef.operationName = 'AddComponente';

export function addComponente(dcOrVars, vars) {
  const { dc: dcInstance, vars: inputVars } = validateArgs(connectorConfig, dcOrVars, vars, true);
  return executeMutation(addComponenteRef(dcInstance, inputVars));
}

export const addEvaluacionRef = (dcOrVars, vars) => {
  const { dc: dcInstance, vars: inputVars} = validateArgs(connectorConfig, dcOrVars, vars, true);
  dcInstance._useGeneratedSdk();
  return mutationRef(dcInstance, 'AddEvaluacion', inputVars);
}
addEvaluacionRef.operationName = 'AddEvaluacion';

export function addEvaluacion(dcOrVars, vars) {
  const { dc: dcInstance, vars: inputVars } = validateArgs(connectorConfig, dcOrVars, vars, true);
  return executeMutation(addEvaluacionRef(dcInstance, inputVars));
}

export const addAlumnoContinuousTrainingRef = (dcOrVars, vars) => {
  const { dc: dcInstance, vars: inputVars} = validateArgs(connectorConfig, dcOrVars, vars, true);
  dcInstance._useGeneratedSdk();
  return mutationRef(dcInstance, 'AddAlumnoContinuousTraining', inputVars);
}
addAlumnoContinuousTrainingRef.operationName = 'AddAlumnoContinuousTraining';

export function addAlumnoContinuousTraining(dcOrVars, vars) {
  const { dc: dcInstance, vars: inputVars } = validateArgs(connectorConfig, dcOrVars, vars, true);
  return executeMutation(addAlumnoContinuousTrainingRef(dcInstance, inputVars));
}

export const linkAlumnoContinuousTrainingAcreditacionRef = (dcOrVars, vars) => {
  const { dc: dcInstance, vars: inputVars} = validateArgs(connectorConfig, dcOrVars, vars, true);
  dcInstance._useGeneratedSdk();
  return mutationRef(dcInstance, 'LinkAlumnoContinuousTrainingAcreditacion', inputVars);
}
linkAlumnoContinuousTrainingAcreditacionRef.operationName = 'LinkAlumnoContinuousTrainingAcreditacion';

export function linkAlumnoContinuousTrainingAcreditacion(dcOrVars, vars) {
  const { dc: dcInstance, vars: inputVars } = validateArgs(connectorConfig, dcOrVars, vars, true);
  return executeMutation(linkAlumnoContinuousTrainingAcreditacionRef(dcInstance, inputVars));
}

export const updateComponenteRef = (dcOrVars, vars) => {
  const { dc: dcInstance, vars: inputVars} = validateArgs(connectorConfig, dcOrVars, vars, true);
  dcInstance._useGeneratedSdk();
  return mutationRef(dcInstance, 'UpdateComponente', inputVars);
}
updateComponenteRef.operationName = 'UpdateComponente';

export function updateComponente(dcOrVars, vars) {
  const { dc: dcInstance, vars: inputVars } = validateArgs(connectorConfig, dcOrVars, vars, true);
  return executeMutation(updateComponenteRef(dcInstance, inputVars));
}

export const updateEvaluacionRef = (dcOrVars, vars) => {
  const { dc: dcInstance, vars: inputVars} = validateArgs(connectorConfig, dcOrVars, vars, true);
  dcInstance._useGeneratedSdk();
  return mutationRef(dcInstance, 'UpdateEvaluacion', inputVars);
}
updateEvaluacionRef.operationName = 'UpdateEvaluacion';

export function updateEvaluacion(dcOrVars, vars) {
  const { dc: dcInstance, vars: inputVars } = validateArgs(connectorConfig, dcOrVars, vars, true);
  return executeMutation(updateEvaluacionRef(dcInstance, inputVars));
}

export const deleteEvaluacionRef = (dcOrVars, vars) => {
  const { dc: dcInstance, vars: inputVars} = validateArgs(connectorConfig, dcOrVars, vars, true);
  dcInstance._useGeneratedSdk();
  return mutationRef(dcInstance, 'DeleteEvaluacion', inputVars);
}
deleteEvaluacionRef.operationName = 'DeleteEvaluacion';

export function deleteEvaluacion(dcOrVars, vars) {
  const { dc: dcInstance, vars: inputVars } = validateArgs(connectorConfig, dcOrVars, vars, true);
  return executeMutation(deleteEvaluacionRef(dcInstance, inputVars));
}

export const deleteComponenteRef = (dcOrVars, vars) => {
  const { dc: dcInstance, vars: inputVars} = validateArgs(connectorConfig, dcOrVars, vars, true);
  dcInstance._useGeneratedSdk();
  return mutationRef(dcInstance, 'DeleteComponente', inputVars);
}
deleteComponenteRef.operationName = 'DeleteComponente';

export function deleteComponente(dcOrVars, vars) {
  const { dc: dcInstance, vars: inputVars } = validateArgs(connectorConfig, dcOrVars, vars, true);
  return executeMutation(deleteComponenteRef(dcInstance, inputVars));
}

export const updateAlumnoContinuousTrainingRef = (dcOrVars, vars) => {
  const { dc: dcInstance, vars: inputVars} = validateArgs(connectorConfig, dcOrVars, vars, true);
  dcInstance._useGeneratedSdk();
  return mutationRef(dcInstance, 'UpdateAlumnoContinuousTraining', inputVars);
}
updateAlumnoContinuousTrainingRef.operationName = 'UpdateAlumnoContinuousTraining';

export function updateAlumnoContinuousTraining(dcOrVars, vars) {
  const { dc: dcInstance, vars: inputVars } = validateArgs(connectorConfig, dcOrVars, vars, true);
  return executeMutation(updateAlumnoContinuousTrainingRef(dcInstance, inputVars));
}

export const updateCalificacionRef = (dcOrVars, vars) => {
  const { dc: dcInstance, vars: inputVars} = validateArgs(connectorConfig, dcOrVars, vars, true);
  dcInstance._useGeneratedSdk();
  return mutationRef(dcInstance, 'UpdateCalificacion', inputVars);
}
updateCalificacionRef.operationName = 'UpdateCalificacion';

export function updateCalificacion(dcOrVars, vars) {
  const { dc: dcInstance, vars: inputVars } = validateArgs(connectorConfig, dcOrVars, vars, true);
  return executeMutation(updateCalificacionRef(dcInstance, inputVars));
}

export const addCalificacionRef = (dcOrVars, vars) => {
  const { dc: dcInstance, vars: inputVars} = validateArgs(connectorConfig, dcOrVars, vars, true);
  dcInstance._useGeneratedSdk();
  return mutationRef(dcInstance, 'AddCalificacion', inputVars);
}
addCalificacionRef.operationName = 'AddCalificacion';

export function addCalificacion(dcOrVars, vars) {
  const { dc: dcInstance, vars: inputVars } = validateArgs(connectorConfig, dcOrVars, vars, true);
  return executeMutation(addCalificacionRef(dcInstance, inputVars));
}

export const addAcreditacionAlumnoRef = (dcOrVars, vars) => {
  const { dc: dcInstance, vars: inputVars} = validateArgs(connectorConfig, dcOrVars, vars, true);
  dcInstance._useGeneratedSdk();
  return mutationRef(dcInstance, 'AddAcreditacionAlumno', inputVars);
}
addAcreditacionAlumnoRef.operationName = 'AddAcreditacionAlumno';

export function addAcreditacionAlumno(dcOrVars, vars) {
  const { dc: dcInstance, vars: inputVars } = validateArgs(connectorConfig, dcOrVars, vars, true);
  return executeMutation(addAcreditacionAlumnoRef(dcInstance, inputVars));
}

export const updateAcreditacionAlumnoRef = (dcOrVars, vars) => {
  const { dc: dcInstance, vars: inputVars} = validateArgs(connectorConfig, dcOrVars, vars, true);
  dcInstance._useGeneratedSdk();
  return mutationRef(dcInstance, 'UpdateAcreditacionAlumno', inputVars);
}
updateAcreditacionAlumnoRef.operationName = 'UpdateAcreditacionAlumno';

export function updateAcreditacionAlumno(dcOrVars, vars) {
  const { dc: dcInstance, vars: inputVars } = validateArgs(connectorConfig, dcOrVars, vars, true);
  return executeMutation(updateAcreditacionAlumnoRef(dcInstance, inputVars));
}

export const deleteAcreditacionAlumnoRef = (dcOrVars, vars) => {
  const { dc: dcInstance, vars: inputVars} = validateArgs(connectorConfig, dcOrVars, vars, true);
  dcInstance._useGeneratedSdk();
  return mutationRef(dcInstance, 'DeleteAcreditacionAlumno', inputVars);
}
deleteAcreditacionAlumnoRef.operationName = 'DeleteAcreditacionAlumno';

export function deleteAcreditacionAlumno(dcOrVars, vars) {
  const { dc: dcInstance, vars: inputVars } = validateArgs(connectorConfig, dcOrVars, vars, true);
  return executeMutation(deleteAcreditacionAlumnoRef(dcInstance, inputVars));
}

export const linkAcreditacionAlumnoCertificadoRef = (dcOrVars, vars) => {
  const { dc: dcInstance, vars: inputVars} = validateArgs(connectorConfig, dcOrVars, vars, true);
  dcInstance._useGeneratedSdk();
  return mutationRef(dcInstance, 'LinkAcreditacionAlumnoCertificado', inputVars);
}
linkAcreditacionAlumnoCertificadoRef.operationName = 'LinkAcreditacionAlumnoCertificado';

export function linkAcreditacionAlumnoCertificado(dcOrVars, vars) {
  const { dc: dcInstance, vars: inputVars } = validateArgs(connectorConfig, dcOrVars, vars, true);
  return executeMutation(linkAcreditacionAlumnoCertificadoRef(dcInstance, inputVars));
}

export const addCertificadoRef = (dcOrVars, vars) => {
  const { dc: dcInstance, vars: inputVars} = validateArgs(connectorConfig, dcOrVars, vars, true);
  dcInstance._useGeneratedSdk();
  return mutationRef(dcInstance, 'AddCertificado', inputVars);
}
addCertificadoRef.operationName = 'AddCertificado';

export function addCertificado(dcOrVars, vars) {
  const { dc: dcInstance, vars: inputVars } = validateArgs(connectorConfig, dcOrVars, vars, true);
  return executeMutation(addCertificadoRef(dcInstance, inputVars));
}

export const updateCertificadoRef = (dcOrVars, vars) => {
  const { dc: dcInstance, vars: inputVars} = validateArgs(connectorConfig, dcOrVars, vars, true);
  dcInstance._useGeneratedSdk();
  return mutationRef(dcInstance, 'UpdateCertificado', inputVars);
}
updateCertificadoRef.operationName = 'UpdateCertificado';

export function updateCertificado(dcOrVars, vars) {
  const { dc: dcInstance, vars: inputVars } = validateArgs(connectorConfig, dcOrVars, vars, true);
  return executeMutation(updateCertificadoRef(dcInstance, inputVars));
}

export const deleteCertificadoRef = (dcOrVars, vars) => {
  const { dc: dcInstance, vars: inputVars} = validateArgs(connectorConfig, dcOrVars, vars, true);
  dcInstance._useGeneratedSdk();
  return mutationRef(dcInstance, 'DeleteCertificado', inputVars);
}
deleteCertificadoRef.operationName = 'DeleteCertificado';

export function deleteCertificado(dcOrVars, vars) {
  const { dc: dcInstance, vars: inputVars } = validateArgs(connectorConfig, dcOrVars, vars, true);
  return executeMutation(deleteCertificadoRef(dcInstance, inputVars));
}

export const insertExpedicionAlumnoRef = (dcOrVars, vars) => {
  const { dc: dcInstance, vars: inputVars} = validateArgs(connectorConfig, dcOrVars, vars, true);
  dcInstance._useGeneratedSdk();
  return mutationRef(dcInstance, 'InsertExpedicionAlumno', inputVars);
}
insertExpedicionAlumnoRef.operationName = 'InsertExpedicionAlumno';

export function insertExpedicionAlumno(dcOrVars, vars) {
  const { dc: dcInstance, vars: inputVars } = validateArgs(connectorConfig, dcOrVars, vars, true);
  return executeMutation(insertExpedicionAlumnoRef(dcInstance, inputVars));
}

export const linkExpedicionAlumnoDegreeRef = (dcOrVars, vars) => {
  const { dc: dcInstance, vars: inputVars} = validateArgs(connectorConfig, dcOrVars, vars, true);
  dcInstance._useGeneratedSdk();
  return mutationRef(dcInstance, 'LinkExpedicionAlumnoDegree', inputVars);
}
linkExpedicionAlumnoDegreeRef.operationName = 'LinkExpedicionAlumnoDegree';

export function linkExpedicionAlumnoDegree(dcOrVars, vars) {
  const { dc: dcInstance, vars: inputVars } = validateArgs(connectorConfig, dcOrVars, vars, true);
  return executeMutation(linkExpedicionAlumnoDegreeRef(dcInstance, inputVars));
}

export const linkExpedicionAlumnoCertificateRef = (dcOrVars, vars) => {
  const { dc: dcInstance, vars: inputVars} = validateArgs(connectorConfig, dcOrVars, vars, true);
  dcInstance._useGeneratedSdk();
  return mutationRef(dcInstance, 'LinkExpedicionAlumnoCertificate', inputVars);
}
linkExpedicionAlumnoCertificateRef.operationName = 'LinkExpedicionAlumnoCertificate';

export function linkExpedicionAlumnoCertificate(dcOrVars, vars) {
  const { dc: dcInstance, vars: inputVars } = validateArgs(connectorConfig, dcOrVars, vars, true);
  return executeMutation(linkExpedicionAlumnoCertificateRef(dcInstance, inputVars));
}

export const insertDegreeExpeditionRef = (dcOrVars, vars) => {
  const { dc: dcInstance, vars: inputVars} = validateArgs(connectorConfig, dcOrVars, vars, true);
  dcInstance._useGeneratedSdk();
  return mutationRef(dcInstance, 'InsertDegreeExpedition', inputVars);
}
insertDegreeExpeditionRef.operationName = 'InsertDegreeExpedition';

export function insertDegreeExpedition(dcOrVars, vars) {
  const { dc: dcInstance, vars: inputVars } = validateArgs(connectorConfig, dcOrVars, vars, true);
  return executeMutation(insertDegreeExpeditionRef(dcInstance, inputVars));
}

export const updateDegreeExpeditionRef = (dcOrVars, vars) => {
  const { dc: dcInstance, vars: inputVars} = validateArgs(connectorConfig, dcOrVars, vars, true);
  dcInstance._useGeneratedSdk();
  return mutationRef(dcInstance, 'UpdateDegreeExpedition', inputVars);
}
updateDegreeExpeditionRef.operationName = 'UpdateDegreeExpedition';

export function updateDegreeExpedition(dcOrVars, vars) {
  const { dc: dcInstance, vars: inputVars } = validateArgs(connectorConfig, dcOrVars, vars, true);
  return executeMutation(updateDegreeExpeditionRef(dcInstance, inputVars));
}

export const insertCertificateExpeditionRef = (dcOrVars, vars) => {
  const { dc: dcInstance, vars: inputVars} = validateArgs(connectorConfig, dcOrVars, vars, true);
  dcInstance._useGeneratedSdk();
  return mutationRef(dcInstance, 'InsertCertificateExpedition', inputVars);
}
insertCertificateExpeditionRef.operationName = 'InsertCertificateExpedition';

export function insertCertificateExpedition(dcOrVars, vars) {
  const { dc: dcInstance, vars: inputVars } = validateArgs(connectorConfig, dcOrVars, vars, true);
  return executeMutation(insertCertificateExpeditionRef(dcInstance, inputVars));
}

export const updateCertificateExpeditionRef = (dcOrVars, vars) => {
  const { dc: dcInstance, vars: inputVars} = validateArgs(connectorConfig, dcOrVars, vars, true);
  dcInstance._useGeneratedSdk();
  return mutationRef(dcInstance, 'UpdateCertificateExpedition', inputVars);
}
updateCertificateExpeditionRef.operationName = 'UpdateCertificateExpedition';

export function updateCertificateExpedition(dcOrVars, vars) {
  const { dc: dcInstance, vars: inputVars } = validateArgs(connectorConfig, dcOrVars, vars, true);
  return executeMutation(updateCertificateExpeditionRef(dcInstance, inputVars));
}

export const insertAlumnoIpeRef = (dcOrVars, vars) => {
  const { dc: dcInstance, vars: inputVars} = validateArgs(connectorConfig, dcOrVars, vars, true);
  dcInstance._useGeneratedSdk();
  return mutationRef(dcInstance, 'InsertAlumnoIpe', inputVars);
}
insertAlumnoIpeRef.operationName = 'InsertAlumnoIpe';

export function insertAlumnoIpe(dcOrVars, vars) {
  const { dc: dcInstance, vars: inputVars } = validateArgs(connectorConfig, dcOrVars, vars, true);
  return executeMutation(insertAlumnoIpeRef(dcInstance, inputVars));
}

export const updateAlumnoIpeRef = (dcOrVars, vars) => {
  const { dc: dcInstance, vars: inputVars} = validateArgs(connectorConfig, dcOrVars, vars, true);
  dcInstance._useGeneratedSdk();
  return mutationRef(dcInstance, 'UpdateAlumnoIpe', inputVars);
}
updateAlumnoIpeRef.operationName = 'UpdateAlumnoIpe';

export function updateAlumnoIpe(dcOrVars, vars) {
  const { dc: dcInstance, vars: inputVars } = validateArgs(connectorConfig, dcOrVars, vars, true);
  return executeMutation(updateAlumnoIpeRef(dcInstance, inputVars));
}

export const addInstitucionPuiRef = (dcOrVars, vars) => {
  const { dc: dcInstance, vars: inputVars} = validateArgs(connectorConfig, dcOrVars, vars, true);
  dcInstance._useGeneratedSdk();
  return mutationRef(dcInstance, 'AddInstitucionPui', inputVars);
}
addInstitucionPuiRef.operationName = 'AddInstitucionPui';

export function addInstitucionPui(dcOrVars, vars) {
  const { dc: dcInstance, vars: inputVars } = validateArgs(connectorConfig, dcOrVars, vars, true);
  return executeMutation(addInstitucionPuiRef(dcInstance, inputVars));
}

export const addCarreraPuiRef = (dcOrVars, vars) => {
  const { dc: dcInstance, vars: inputVars} = validateArgs(connectorConfig, dcOrVars, vars, true);
  dcInstance._useGeneratedSdk();
  return mutationRef(dcInstance, 'AddCarreraPui', inputVars);
}
addCarreraPuiRef.operationName = 'AddCarreraPui';

export function addCarreraPui(dcOrVars, vars) {
  const { dc: dcInstance, vars: inputVars } = validateArgs(connectorConfig, dcOrVars, vars, true);
  return executeMutation(addCarreraPuiRef(dcInstance, inputVars));
}

export const updateAlumnoGrupoTurnoCicloRef = (dcOrVars, vars) => {
  const { dc: dcInstance, vars: inputVars} = validateArgs(connectorConfig, dcOrVars, vars, true);
  dcInstance._useGeneratedSdk();
  return mutationRef(dcInstance, 'UpdateAlumnoGrupoTurnoCiclo', inputVars);
}
updateAlumnoGrupoTurnoCicloRef.operationName = 'UpdateAlumnoGrupoTurnoCiclo';

export function updateAlumnoGrupoTurnoCiclo(dcOrVars, vars) {
  const { dc: dcInstance, vars: inputVars } = validateArgs(connectorConfig, dcOrVars, vars, true);
  return executeMutation(updateAlumnoGrupoTurnoCicloRef(dcInstance, inputVars));
}

export const updateAlumnoPlanFieldsRef = (dcOrVars, vars) => {
  const { dc: dcInstance, vars: inputVars} = validateArgs(connectorConfig, dcOrVars, vars, true);
  dcInstance._useGeneratedSdk();
  return mutationRef(dcInstance, 'UpdateAlumnoPlanFields', inputVars);
}
updateAlumnoPlanFieldsRef.operationName = 'UpdateAlumnoPlanFields';

export function updateAlumnoPlanFields(dcOrVars, vars) {
  const { dc: dcInstance, vars: inputVars } = validateArgs(connectorConfig, dcOrVars, vars, true);
  return executeMutation(updateAlumnoPlanFieldsRef(dcInstance, inputVars));
}

export const insertAntecedentesRef = (dcOrVars, vars) => {
  const { dc: dcInstance, vars: inputVars} = validateArgs(connectorConfig, dcOrVars, vars, true);
  dcInstance._useGeneratedSdk();
  return mutationRef(dcInstance, 'InsertAntecedentes', inputVars);
}
insertAntecedentesRef.operationName = 'InsertAntecedentes';

export function insertAntecedentes(dcOrVars, vars) {
  const { dc: dcInstance, vars: inputVars } = validateArgs(connectorConfig, dcOrVars, vars, true);
  return executeMutation(insertAntecedentesRef(dcInstance, inputVars));
}

export const updateAntecedentesRef = (dcOrVars, vars) => {
  const { dc: dcInstance, vars: inputVars} = validateArgs(connectorConfig, dcOrVars, vars, true);
  dcInstance._useGeneratedSdk();
  return mutationRef(dcInstance, 'UpdateAntecedentes', inputVars);
}
updateAntecedentesRef.operationName = 'UpdateAntecedentes';

export function updateAntecedentes(dcOrVars, vars) {
  const { dc: dcInstance, vars: inputVars } = validateArgs(connectorConfig, dcOrVars, vars, true);
  return executeMutation(updateAntecedentesRef(dcInstance, inputVars));
}

export const updateContinuousTrainingRef = (dcOrVars, vars) => {
  const { dc: dcInstance, vars: inputVars} = validateArgs(connectorConfig, dcOrVars, vars, true);
  dcInstance._useGeneratedSdk();
  return mutationRef(dcInstance, 'UpdateContinuousTraining', inputVars);
}
updateContinuousTrainingRef.operationName = 'UpdateContinuousTraining';

export function updateContinuousTraining(dcOrVars, vars) {
  const { dc: dcInstance, vars: inputVars } = validateArgs(connectorConfig, dcOrVars, vars, true);
  return executeMutation(updateContinuousTrainingRef(dcInstance, inputVars));
}

export const updateEstatusExpedienteRef = (dcOrVars, vars) => {
  const { dc: dcInstance, vars: inputVars} = validateArgs(connectorConfig, dcOrVars, vars, true);
  dcInstance._useGeneratedSdk();
  return mutationRef(dcInstance, 'UpdateEstatusExpediente', inputVars);
}
updateEstatusExpedienteRef.operationName = 'UpdateEstatusExpediente';

export function updateEstatusExpediente(dcOrVars, vars) {
  const { dc: dcInstance, vars: inputVars } = validateArgs(connectorConfig, dcOrVars, vars, true);
  return executeMutation(updateEstatusExpedienteRef(dcInstance, inputVars));
}

export const updateEstatusTituloRef = (dcOrVars, vars) => {
  const { dc: dcInstance, vars: inputVars} = validateArgs(connectorConfig, dcOrVars, vars, true);
  dcInstance._useGeneratedSdk();
  return mutationRef(dcInstance, 'UpdateEstatusTitulo', inputVars);
}
updateEstatusTituloRef.operationName = 'UpdateEstatusTitulo';

export function updateEstatusTitulo(dcOrVars, vars) {
  const { dc: dcInstance, vars: inputVars } = validateArgs(connectorConfig, dcOrVars, vars, true);
  return executeMutation(updateEstatusTituloRef(dcInstance, inputVars));
}

export const updateEstatusTituloTestRef = (dcOrVars, vars) => {
  const { dc: dcInstance, vars: inputVars} = validateArgs(connectorConfig, dcOrVars, vars, true);
  dcInstance._useGeneratedSdk();
  return mutationRef(dcInstance, 'UpdateEstatusTituloTest', inputVars);
}
updateEstatusTituloTestRef.operationName = 'UpdateEstatusTituloTest';

export function updateEstatusTituloTest(dcOrVars, vars) {
  const { dc: dcInstance, vars: inputVars } = validateArgs(connectorConfig, dcOrVars, vars, true);
  return executeMutation(updateEstatusTituloTestRef(dcInstance, inputVars));
}

export const updateEstatusCertificadoTotalRef = (dcOrVars, vars) => {
  const { dc: dcInstance, vars: inputVars} = validateArgs(connectorConfig, dcOrVars, vars, true);
  dcInstance._useGeneratedSdk();
  return mutationRef(dcInstance, 'UpdateEstatusCertificadoTotal', inputVars);
}
updateEstatusCertificadoTotalRef.operationName = 'UpdateEstatusCertificadoTotal';

export function updateEstatusCertificadoTotal(dcOrVars, vars) {
  const { dc: dcInstance, vars: inputVars } = validateArgs(connectorConfig, dcOrVars, vars, true);
  return executeMutation(updateEstatusCertificadoTotalRef(dcInstance, inputVars));
}

export const updateEstatusCertificadoTotalTestRef = (dcOrVars, vars) => {
  const { dc: dcInstance, vars: inputVars} = validateArgs(connectorConfig, dcOrVars, vars, true);
  dcInstance._useGeneratedSdk();
  return mutationRef(dcInstance, 'UpdateEstatusCertificadoTotalTest', inputVars);
}
updateEstatusCertificadoTotalTestRef.operationName = 'UpdateEstatusCertificadoTotalTest';

export function updateEstatusCertificadoTotalTest(dcOrVars, vars) {
  const { dc: dcInstance, vars: inputVars } = validateArgs(connectorConfig, dcOrVars, vars, true);
  return executeMutation(updateEstatusCertificadoTotalTestRef(dcInstance, inputVars));
}

export const updateEstatusCertificadoParcialRef = (dcOrVars, vars) => {
  const { dc: dcInstance, vars: inputVars} = validateArgs(connectorConfig, dcOrVars, vars, true);
  dcInstance._useGeneratedSdk();
  return mutationRef(dcInstance, 'UpdateEstatusCertificadoParcial', inputVars);
}
updateEstatusCertificadoParcialRef.operationName = 'UpdateEstatusCertificadoParcial';

export function updateEstatusCertificadoParcial(dcOrVars, vars) {
  const { dc: dcInstance, vars: inputVars } = validateArgs(connectorConfig, dcOrVars, vars, true);
  return executeMutation(updateEstatusCertificadoParcialRef(dcInstance, inputVars));
}

export const updateEstatusCertificadoParcialTestRef = (dcOrVars, vars) => {
  const { dc: dcInstance, vars: inputVars} = validateArgs(connectorConfig, dcOrVars, vars, true);
  dcInstance._useGeneratedSdk();
  return mutationRef(dcInstance, 'UpdateEstatusCertificadoParcialTest', inputVars);
}
updateEstatusCertificadoParcialTestRef.operationName = 'UpdateEstatusCertificadoParcialTest';

export function updateEstatusCertificadoParcialTest(dcOrVars, vars) {
  const { dc: dcInstance, vars: inputVars } = validateArgs(connectorConfig, dcOrVars, vars, true);
  return executeMutation(updateEstatusCertificadoParcialTestRef(dcInstance, inputVars));
}

export const updateAlumnoRef = (dcOrVars, vars) => {
  const { dc: dcInstance, vars: inputVars} = validateArgs(connectorConfig, dcOrVars, vars, true);
  dcInstance._useGeneratedSdk();
  return mutationRef(dcInstance, 'UpdateAlumno', inputVars);
}
updateAlumnoRef.operationName = 'UpdateAlumno';

export function updateAlumno(dcOrVars, vars) {
  const { dc: dcInstance, vars: inputVars } = validateArgs(connectorConfig, dcOrVars, vars, true);
  return executeMutation(updateAlumnoRef(dcInstance, inputVars));
}

